import './lle_opted_locationdetails.css'
import React, { useState, useEffect, useTransition } from "react";
import { useNavigate } from 'react-router-dom';
import jwt from 'jwt-decode';

import { GET_ADDRESS_BY_PINCODE, UPLOAD_DCUMENT, authKey, GET_ALL_BLOCKLIST_AND_REVENUECIRCLE } from '../../../../common/URLs';
import { useLocation } from 'react-router-dom';
import { LAND_DOCUMENT, BLOCK_LIST, REVENUE_CIRCLE, LAND_AREA_UNIT } from '../../../../common/constants';
import { landAreaValidation, VALIDATION } from '../../../../common/commonValidations';
import { CommonPincodeMUI } from '../../../../common/common-pincode/commonPincodeMUI';
import { LocationPointMUI } from '../../../../common/locationPoints/locationPointMUI';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { Container, Card, CardContent, Button, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { PROD } from '../../../../common/constants';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';
import { ArrowBackIosNewIcon, ArrowForwardIosIcon } from '../../../../common/icons';
import apiClient from '../../../../axios';

const ChooseFileUpload = {
    backgroundColor: "#D9D9D9",
    borderRadius: "1vw",
    color: "#000000",
    marginLeft: "5vw",
    marginTop: "3vh",
    height: "5vh",
    padding: "1vh",
};

const LLEOptedLocation = () => {
    const {t, i18n} = useTranslation();
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [backButtonData, setBackButtonData] = useState();
    const [prevScreenData, setPrevScreenData] = useState();
    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const [landTypeFileName, setLandTypeFileName] = useState();
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [documentDetailsArr, setDocumentDetailsArr] = useState([]);
    const [documentDetailsObj, setDocumentDetailsObj] = useState({
        id: null,
        documentType: null,
        documentName: null, //
        documentBlobName: null, //
        documentPath: null,
        documentContainerName: "stakeholder",
        stakeholderType: "lle",
        stakeholderDetailId: null,
        isActive: 1
    });


    const [details, setDetails] = useState({
        fullName: '',
        mobileNo: '',
        emailId: '',
        companyType: '',
        chippingPincode: '',
        chippingState: '',
        chippingDistrict: '',
        chippingRevenueCircle: '',
        chippingBlockName: '',
        latitudes: '',
        longitudes: '',
        landArealle: '',
        quantitylle: '',
        Owned_type: 'Owned',
        address: '',
        landAreaValue: '',
        landAreaUnit: 'sq ft',
    });
    const navigate = useNavigate();
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState({
        fullNameError: '',
        contactPersonNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        addressError: '',
        latitudesError: '',
        longitudesError: '',
        landArealleError: '',
        quantitylleError: '',
        Owned_typeError: '',
        landAreaError: '',

    });
    const [showOwnedLabel, setOwnedLabel] = useState(true);
    const [showLeasedLabel, setLeasedLabel] = useState(false);
    const [loc, setLoc] = useState();
    const [emailId, setEmailId] = useState();

    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const decoded_urn = decoded.extension_URN
            const email = decoded.emails?.[0]
            setLoc(decoded_urn);
            setEmailId(emailId);
        }
    }, [getLocalStorageItem('id_token')]);


    useEffect(() => {
        setBackButtonData(location.state.data);
        if (backButtonData) {
            setDetails({
                chippingPincode: backButtonData.chippingUnitPincode,
                latitudes: backButtonData.chippingUnitLatitude,
                longitudes: backButtonData.chippingUnitLongitude,
                landArealle: backButtonData.estimatedLandArea,
                quantitylle: backButtonData.estimatedBambooQuantity,
                address: backButtonData.chippingUnitAddress,
                Owned_type: backButtonData.landType ? backButtonData.landType : "Owned",
                chippingState: backButtonData.chippingUnitState,
                chippingDistrict: backButtonData.chippingUnitDistrict,
                chippingBlockName: backButtonData.chippingUnitBlockName,
                chippingRevenueCircle: backButtonData.chippingUnitRevenueCircle,
                landAreaUnit: backButtonData.landArea ? backButtonData.landArea?.split(" ")[1] : 'sq ft',
                landAreaValue: backButtonData.landArea ? backButtonData.landArea?.split(" ")[0] : '',
            })
            setSelectedApplicant(backButtonData.applicantType)
        }
    }, [backButtonData]);

    useEffect(() => {
        setPrevScreenData(location.state.data)
        setDocumentDetailsArr(location.state.data?.documents)
        setSelectedApplicant(location.state.data?.applicantType);

    }, [prevScreenData]);

    useEffect(() => {
        if (selectedFile) {
            getDocumentUploadDetails();
        }
    }, [selectedFile]);

    useEffect(() => {
        if (documentUploadDetails) {
            setDocumentDetailsObj({
                ...documentDetailsObj,
                documentName: documentUploadDetails?.blobResponse?.fileName,
                documentBlobName: documentUploadDetails?.blobResponse?.blobFileName
            });
        }
    }, [documentUploadDetails]);

    useEffect(() => {
        if (documentDetailsObj.documentBlobName) {
            let tempArr = documentDetailsArr.filter((item) => item.documentType !== documentDetailsObj.documentType)
            tempArr?.push(documentDetailsObj)
            setDocumentDetailsArr(tempArr);
        }

    }, [documentDetailsObj.documentBlobName]);
    const getDocumentUploadDetails = () => {
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "stakeholder");
        apiClient
            .post(
                UPLOAD_DCUMENT,
                formData,
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                setDocumentUploadDetails(response.data);
            })

            .catch(function (error) {
                console.log(error);
            });
    }
    const uploadDocument = (e, type) => {
        setSelectedFile(e.target.files[0]);
        setDocumentDetailsObj({
            ...documentDetailsObj,
            documentType: type,
            stakeholderDetailId: null,
        })

        if (type === LAND_DOCUMENT) {
            setLandTypeFileName(e.target.files[0].name)
        }
    };

    const handleChange = (e) => {
        setDetails({ ...details, [e.target.name]: e.target.value })

        if (e.target.name === "address") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value) })
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else {
                setErrorMessage({ ...errorMessage, addressError: "Please enter Address" })

            }
        }

        if (e.target.name === "latitudes") {
            const limit = 18;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if (e.target.value.length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value.slice(0, limit))) {
                setErrorMessage({ ...errorMessage, latitudesError: " " })
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })

            } else {
                setErrorMessage({ ...errorMessage, latitudesError: "Please enter valid latitude" })

            }
        }
        if (e.target.name === "longitudes") {
            const limit = 18;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if (e.target.value.length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value.slice(0, limit))) {
                setErrorMessage({ ...errorMessage, longitudesError: "" })
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })

            } else {
                setErrorMessage({ ...errorMessage, longitudesError: "Please enter valid longitude" })

            }
        }
        if (e.target.name === "landAreaValue") {
            const limit = 10;
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, landAreaError: "" })
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            } else {
                setErrorMessage({ ...errorMessage, landAreaError: "Please enter Land Area" })

            }
        }
        if (e.target.name === "landArealle") {
            var slicedLandArea = landAreaValidation(e.target.value);
            setDetails({ ...details, [e.target.name]: slicedLandArea })
            if (slicedLandArea.length == 0) {
                setErrorMessage({ ...errorMessage, landArealleError: "Please enter Land Area " })
            }
            else setErrorMessage({ ...errorMessage, landArealleError: "" })
        }

        if (e.target.name === "quantitylle") {
            var slicedquantitylle = landAreaValidation(e.target.value);
            setDetails({ ...details, [e.target.name]: slicedquantitylle })
            if (slicedquantitylle.length == 0) {
                setErrorMessage({ ...errorMessage, quantitylleError: "Please enter Quantity" })
            }
            else setErrorMessage({ ...errorMessage, quantitylleError: "" })
        }

        if (e.target.name === "chippingpincode") {
            const limit = 6;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 6) {
                setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
            }
            else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }

    };
    const onSubmit = (e) => {
        e.preventDefault();
        // if (details.address) {
        //     if (!details?.chippingPincode || details?.chippingPincode?.length < 6) {
        //         setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
        //     } else {
        //         setErrorMessage({ ...errorMessage, pincodeError: "" });
        //         if (details.chippingState) {
        //             if (loc != null || details?.latitudes) {
        //                 if (loc != null || details?.longitudes) {
        //                     if (details.landAreaValue) {
        //                         if (details.quantitylle) {
        //                             if (details.landArealle) {

                                        submitLLEDetails();
        //                             }
        //                             else setErrorMessage({ ...errorMessage, landArealleError: "Please enter Land Area " });
        //                         } else setErrorMessage({ ...errorMessage, quantitylleError: "Please enter Quantity " });
        //                     } else setErrorMessage({ ...errorMessage, landAreaError: "Please enter Land Area  " });
        //                 } else setErrorMessage({ ...errorMessage, longitudesError: "Please enter  longitude " });
        //             } else setErrorMessage({ ...errorMessage, latitudesError: "Please enter  latitude" });

        //         } else
        //             setErrorMessage({ ...errorMessage, searchError: "Please enter pincode and search " });
        //     }


        // } else setErrorMessage({ ...errorMessage, addressError: "Please enter Address" });
    }
    const submitLLEDetails = () => {
        const dataForApi = {
            ...prevScreenData,
            "chippingUnitAddress": details.address,
            "chippingUnitRevenueCircle": details.chippingRevenueCircle,
            "chippingUnitBlockName": details.chippingBlockName,
            "chippingUnitDistrict": details.chippingDistrict,
            "chippingUnitState": details.chippingState,
            "chippingUnitPincode": details.chippingPincode,
            "chippingUnitLatitude": details.latitudes,
            "chippingUnitLongitude": details.longitudes,
            "estimatedBambooQuantity": details.quantitylle,
            "estimatedLandArea": details.landArealle,
            "landArea": details.landAreaValue + " " + details.landAreaUnit


        }
        navigate(getLocalStorageItem('id_token') ? "/registrationHome/preregistration/llelandSubCategory" : '/preregistration/llelandSubCategory', { state: { data: dataForApi } });

    }
    const onApplicantClick = (e) => {
        e.preventDefault();
        setSelectedApplicant(e.target.value)
    }
    const onRadioButtonClick = (e) => {
        setDetails({ ...details, [e.target.name]: e.target.value })
        if (e.target.name === "Owned_type") {
            if (e.target.value === "Owned") {
                setOwnedLabel(true);
                setLeasedLabel(false);
            }
            else if (e.target.value === "Leased") {
                setOwnedLabel(false);
                setLeasedLabel(true);
            }

        }

    }

    const onLocationPoint = (position) => {
        setDetails({
            ...details,
            latitudes: position?.coords?.latitude ? position?.coords?.latitude : position.Latitude,
            longitudes: position?.coords?.longitude ? position?.coords?.longitude : position.Longitude
        });
    }

    const getUpdatedChippingAddressData = (data) => {
        setDetails({
            ...details,
            chippingPincode: data.pincode,
            chippingState: data.pincodeState,
            chippingDistrict: data.pincodeDistrict,
            chippingSubDivision: data.pincodeSubDivision,
            chippingRevenueCircle: data.selectedRevenueCircle,
            chippingBlockName: data.selectedBlockName,
        });
        setErrorMessage({...errorMessage, pincodeError: ""})
    }
    const handleChippingChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails({ ...details, chippingBlockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails({ ...details, chippingRevenueCircle: e.target.value, });
        }
    }
    return (
        <>
            <Container maxWidth="xxl">
            {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG06</p>}
                <Card>
                    <CardContent>
                        <Typography variant="subtitle2" gutterBottom>
                            {t('preReg.applicantType')}
                        </Typography>
                        <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                            color="primary"
                            value={selectedApplicant}
                            exclusive
                            onChange={(e) => onApplicantClick(e)}
                            aria-label="Platform"
                        >
                            <ToggleButton disabled value="Individual">{t('preReg.individual')}</ToggleButton>
                            <ToggleButton disabled value="SHG/Co-opetative">{t('preReg.shg')}/{t('preReg.cooperative')}</ToggleButton>
                            <ToggleButton disabled value="Firm/Enterprise">{t('preReg.firm')}/{t('preReg.enterprise')}</ToggleButton>
                        </ToggleButtonGroup>
                        <Grid container spacing={2} direction="row" mt={1}>
                            <Grid item xs={12} lg={6}>
                                <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                    {t('preReg.optedChippingLocationDetails')}
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            // required
                                            multiline
                                            error={errorMessage.addressError}
                                            helperText={errorMessage.addressError}
                                            type="text"
                                            label={t('main.address')}
                                            name="address"
                                            value={details.address}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                        notRequired={true}
                                        pincode={details?.chippingPincode}
                                        state={details?.chippingState}
                                        district={details?.chippingDistrict}
                                        revenueCircle={details?.chippingRevenueCircle}
                                        blockName={details?.chippingBlockName}
                                        onHandleCallback={getUpdatedChippingAddressData}
                                        pincodeError={errorMessage.pincodeError}
                                        searchError={errorMessage.searchError}
                                        handleChangeSelect={handleChippingChangeSelect}
                                    />
                                    <Grid item xs={12}>
                                            <LocationPointMUI
                                                latitudeLabel="Latitude"
                                                longitudeLabel="Longitude"
                                                latitudeName={t('preReg.latitude')}
                                                longitudeName={t('preReg.longitude')}
                                                latitude={details?.latitudes}
                                                longitude={details?.longitudes}
                                                callBackLocation={onLocationPoint}
                                                latitudesError={errorMessage.latitudesError}
                                                longitudesError={errorMessage.longitudesError}
                                            />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            // required
                                            error={errorMessage.landAreaError}
                                            helperText={errorMessage.landAreaError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.landArea')}
                                            name="landAreaValue"
                                            value={details.landAreaValue}
                                            onChange={(e) => handleChange(e)}
                                            InputProps={{
                                                endAdornment: (
                                                    <Select
                                                        variant="standard"
                                                        size="small"
                                                        name="landAreaUnit"
                                                        value={details.landAreaUnit}
                                                        onChange={(e) => handleChange(e)}
                                                    >
                                                        {LAND_AREA_UNIT.map((option) => (
                                                            <MenuItem key={option} value={option}>
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Typography variant="h6" style={{ marginBottom: "1em", display: "flex", flexDirection: "row" }} gutterBottom>
                                   {t('preReg.estimatedBambooAvailability')}<Typography style={{ marginTop: 4 }} variant="subtitle2" gutterBottom>
                                        {t('preReg.within4050radius')}
                                    </Typography>
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            // required
                                            error={errorMessage.quantitylleError}
                                            helperText={errorMessage.quantitylleError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.quantity')}
                                            name="quantitylle"
                                            value={details.quantitylle}
                                            onChange={(e) => handleChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            // required
                                            error={errorMessage.landArealleError}
                                            helperText={errorMessage.landArealleError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.landAreaBigha')}
                                            name="landArealle"
                                            value={details.landArealle}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" startIcon={<ArrowBackIosNewIcon />} onClick={() => (navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/lledetailsScreenTwo' : '/preregistration/lledetailsScreenTwo', { state: { data: prevScreenData } }))}>{t('preReg.previous')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" endIcon={<ArrowForwardIosIcon />} onClick={(e) => onSubmit(e)}>{t('preReg.next')}</Button>
                </Box>
            </Container>
        </>
    );
}

export default LLEOptedLocation;
